
var Globalize = require('globalize/dist/globalize-runtime');
require('globalize/dist/globalize-runtime/number');
require('globalize/dist/globalize-runtime/plural');
require('globalize/dist/globalize-runtime/message');
require('globalize/dist/globalize-runtime/date');
var validateParameterTypeNumber = Globalize._validateParameterTypeNumber;
var validateParameterPresence = Globalize._validateParameterPresence;
var numberRound = Globalize._numberRound;
var numberFormat = Globalize._numberFormat;
var numberFormatterFn = Globalize._numberFormatterFn;
var validateParameterTypeString = Globalize._validateParameterTypeString;
var numberParse = Globalize._numberParse;
var numberParserFn = Globalize._numberParserFn;
var pluralGeneratorFn = Globalize._pluralGeneratorFn;
var validateParameterTypeMessageVariables = Globalize._validateParameterTypeMessageVariables;
var messageFormat = Globalize._messageFormat;
var messageFormatterFn = Globalize._messageFormatterFn;
var validateParameterTypeDate = Globalize._validateParameterTypeDate;
var dateToPartsFormat = Globalize._dateToPartsFormat;
var dateToPartsFormatterFn = Globalize._dateToPartsFormatterFn;
var dateFormat = Globalize._dateFormat;
var dateFormatterFn = Globalize._dateFormatterFn;
var dateTokenizer = Globalize._dateTokenizer;
var dateParse = Globalize._dateParse;
var dateParserFn = Globalize._dateParserFn;

Globalize.b1144835137 = numberFormatterFn(["",,2,0,0,,,,,,"","00","-00","-","",numberRound(),"∞","非數值",{".":".",",":",","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.b664356225 = numberFormatterFn(["",,4,0,0,,,,,,"","0000","-0000","-","",numberRound(),"∞","非數值",{".":".",",":",","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.b1422414155 = numberFormatterFn(["",,1,0,0,,,,,,"","0","-0","-","",numberRound(),"∞","非數值",{".":".",",":",","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.b387277764 = numberParserFn([{".":".",",":",","%":"%","+":"+","-":"-","E":"E","‰":"‰"},,{"infinity":/^∞/,"nan":/^非數值/,"negativePrefix":/^-/,"negativeSuffix":/^/,"number":/^\d+/,"prefix":/^/,"suffix":/^/}]);
Globalize.a1784984755 = pluralGeneratorFn(function(n
) {
  return 'other';
});
Globalize.a1948465439 = messageFormatterFn((function(  ) {
  return function(d) { return "登入"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b641619189 = messageFormatterFn((function(  ) {
  return function(d) { return "登入"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b172604544 = messageFormatterFn((function(  ) {
  return function(d) { return "電子郵件地址"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1433979353 = messageFormatterFn((function(  ) {
  return function(d) { return "密碼"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1436457464 = messageFormatterFn((function(  ) {
  return function(d) { return "這是公共或共享裝置"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1777399119 = messageFormatterFn((function(  ) {
  return function(d) { return "不是您的裝置？勾選此方塊即會在電腦閒置時提早登出帳戶。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a820423820 = messageFormatterFn((function(  ) {
  return function(d) { return "保持登入"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1482057902 = messageFormatterFn((function(  ) {
  return function(d) { return "勾選此方塊即會在此裝置上保持登入，直到您登出為止。請勿在共用的裝置上勾選。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a852586282 = messageFormatterFn((function(  ) {
  return function(d) { return "忘記密碼？"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1060933659 = messageFormatterFn((function(  ) {
  return function(d) { return "繼續"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a199670264 = messageFormatterFn((function(  ) {
  return function(d) { return "取消"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a262999121 = messageFormatterFn((function(  ) {
  return function(d) { return "返回"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a681467347 = messageFormatterFn((function(  ) {
  return function(d) { return "重新載入"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a316575128 = messageFormatterFn((function(  ) {
  return function(d) { return "登入即表示我同意" + d["0"] + " <a href=" + d["1"] + " " + d["3"] + ">條款和條件</a>及<a href=" + d["2"] + " " + d["4"] + ">隱私權聲明</a>。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1724324298 = messageFormatterFn((function(  ) {
  return function(d) { return "登入即表示我同意 " + d["0"] + " <a href=" + d["1"] + " " + d["5"] + ">條款和條件</a>、<a href=" + d["2"] + " " + d["6"] + ">隱私權聲明</a>及 <a href=" + d["3"] + " " + d["7"] + "> " + d["4"] + " 條款和條件</a>。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1732259086 = messageFormatterFn((function(  ) {
  return function(d) { return "登入即表示加入 " + d["4"] + "，我同意 " + d["0"] + " <a href=" + d["1"] + " " + d["5"] + ">條款和條件</a>和<a href=" + d["2"] + " " + d["6"] + ">隱私權聲明</a>，以及 <a href=" + d["3"] + " " + d["7"] + ">" + d["4"] + " 條款和條件</a>。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1925124893 = messageFormatterFn((function(  ) {
  return function(d) { return "我們進行了例行性的安全檢查，您的帳戶暫時停用。您的資訊都安全無虞，但需要重設一組密碼。請按下方的「忘記密碼？」更改密碼，然後重新登入。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b441423449 = messageFormatterFn((function(  ) {
  return function(d) { return "電子郵件或密碼有誤，請再試一次。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b671019692 = messageFormatterFn((function(  ) {
  return function(d) { return "很抱歉，系統發生錯誤。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b81059622 = messageFormatterFn((function(  ) {
  return function(d) { return "很抱歉，系統發生錯誤。請稍後再試。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b827560456 = messageFormatterFn((function(  ) {
  return function(d) { return "請輸入您的電子郵件地址。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1309719945 = messageFormatterFn((function(  ) {
  return function(d) { return "請輸入有效的電子郵件地址。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1437365423 = messageFormatterFn((function(  ) {
  return function(d) { return "請輸入您的密碼。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b391361669 = messageFormatterFn((function(  ) {
  return function(d) { return "正在驗證登入資訊..."; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1334471914 = messageFormatterFn((function(  ) {
  return function(d) { return "隱藏密碼"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1648814053 = messageFormatterFn((function(  ) {
  return function(d) { return "顯示密碼"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a535063737 = messageFormatterFn((function(  ) {
  return function(d) { return "沒有帳戶嗎？<span><a id=\"createAcctRedirectLink\" href=" + d["0"] + ">註冊帳戶</a></span>"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b511616002 = messageFormatterFn((function(  ) {
  return function(d) { return "登入"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b2034166805 = messageFormatterFn((function(  ) {
  return function(d) { return "無法透過 " + d["0"] + " 登入"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a893381263 = messageFormatterFn((function(  ) {
  return function(d) { return "您可以使用同一組電子郵件登入 " + d["0"] + " 帳戶，只要重設密碼即可，不會影響到 " + d["1"] + " 帳戶。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1122888195 = messageFormatterFn((function(  ) {
  return function(d) { return "請按下方按鈕重設密碼，之後就可以使用電子郵件和新密碼登入 " + d["0"] + " 了。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1107186826 = messageFormatterFn((function(  ) {
  return function(d) { return "SSO 登入"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1280470334 = messageFormatterFn((function(  ) {
  return function(d) { return "使用單一登入功能登入"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b66808714 = messageFormatterFn((function(  ) {
  return function(d) { return "或使用您的 " + d["0"] + " 帳戶登入"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1481299625 = messageFormatterFn((function(  ) {
  return function(d) { return "累積點數兌換免費旅行、用會員價省更多、輕鬆存取行程資訊。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a2070639299 = messageFormatterFn((function(  ) {
  return function(d) { return "此行程結束後可獲得 " + d["0"] + " 點 Expedia Rewards。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b2113294272 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " 帳戶登入"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1832969816 = messageFormatterFn((function(  ) {
  return function(d) { return "在新分頁中開啟"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1216014396 = messageFormatterFn((function(  ) {
  return function(d) { return "條款和條件 (" + d["0"] + ")"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a330982874 = messageFormatterFn((function(  ) {
  return function(d) { return "隱私權聲明 (" + d["0"] + ")"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b476731287 = messageFormatterFn((function(  ) {
  return function(d) { return "One Key 獎勵計畫條款和條件 (" + d["0"] + ") "; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b2042768866 = messageFormatterFn((function(  ) {
  return function(d) { return "忘記密碼"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b241714023 = messageFormatterFn((function(  ) {
  return function(d) { return "重設密碼"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1873412717 = messageFormatterFn((function(  ) {
  return function(d) { return "請輸入您的電子郵件地址，我們會傳送重設密碼的連結給您。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a2096722399 = messageFormatterFn((function(  ) {
  return function(d) { return "傳送重設密碼連結"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a429719716 = messageFormatterFn((function(  ) {
  return function(d) { return "查看您的收件匣"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b625911732 = messageFormatterFn((function(  ) {
  return function(d) { return "我們已傳送一封電子郵件至 " + d["0"] + "，內含重設密碼的連結。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b625910771 = messageFormatterFn((function(  ) {
  return function(d) { return "電子郵件可能需要幾分鐘的時間才會送達，如果 10 分鐘後還沒有收到連結，請檢查您的垃圾郵件。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1228012055 = messageFormatterFn((function(  ) {
  return function(d) { return "重新傳送連結"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1099386735 = messageFormatterFn((function(  ) {
  return function(d) { return "已送出新的連結。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1409857602 = messageFormatterFn((function(  ) {
  return function(d) { return "正在驗證帳戶..."; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a441819966 = messageFormatterFn((function(  ) {
  return function(d) { return "設定密碼"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1322199175 = messageFormatterFn((function(  ) {
  return function(d) { return "歡迎回來"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b374834291 = messageFormatterFn((function(  ) {
  return function(d) { return "請設定一組獨特的密碼。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a160507208 = messageFormatterFn((function(  ) {
  return function(d) { return "成功！"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a368382069 = messageFormatterFn((function(  ) {
  return function(d) { return "之後請使用新的密碼登入。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1759190480 = messageFormatterFn((function(  ) {
  return function(d) { return "重設密碼"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1731929229 = messageFormatterFn((function(  ) {
  return function(d) { return "很抱歉，此要求已過期。如果您還需要變更密碼，請按下方重新傳送重設密碼的電子郵件。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b563205923 = messageFormatterFn((function(  ) {
  return function(d) { return "重新傳送連結"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1647186696 = messageFormatterFn((function(  ) {
  return function(d) { return "正在儲存密碼..."; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a873850884 = messageFormatterFn((function(  ) {
  return function(d) { return "註冊帳戶"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1691848472 = messageFormatterFn((function(  ) {
  return function(d) { return "註冊帳戶"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1314861565 = messageFormatterFn((function(  ) {
  return function(d) { return "電子郵件"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a906287483 = messageFormatterFn((function(  ) {
  return function(d) { return "請輸入您的電子郵件地址。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1659275188 = messageFormatterFn((function(  ) {
  return function(d) { return "請輸入有效的電子郵件地址。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a315983266 = messageFormatterFn((function(  ) {
  return function(d) { return "名字"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1725371674 = messageFormatterFn((function(  ) {
  return function(d) { return "請輸入您的名字。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a630570492 = messageFormatterFn((function(  ) {
  return function(d) { return "姓氏"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1679270012 = messageFormatterFn((function(  ) {
  return function(d) { return "請輸入您的姓氏。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b2108030467 = messageFormatterFn((function(  ) {
  return function(d) { return "請輸入英文字母"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1480952950 = messageFormatterFn((function(  ) {
  return function(d) { return "密碼"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b828887554 = messageFormatterFn((function(  ) {
  return function(d) { return "請輸入您的密碼。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1731580301 = messageFormatterFn((function(  ) {
  return function(d) { return "請輸入有效的密碼。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1386490195 = messageFormatterFn((function(  ) {
  return function(d) { return "長度必須是 9 - 64 個字元"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1386491156 = messageFormatterFn((function(  ) {
  return function(d) { return "必須要有英文和數字"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1386492117 = messageFormatterFn((function(  ) {
  return function(d) { return "1 個特殊字元 (~ " + "#" + " @ $ % & ! * _ ? ^ -)"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1386493078 = messageFormatterFn((function(  ) {
  return function(d) { return "密碼不得包含空格"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1447267395 = messageFormatterFn((function(  ) {
  return function(d) { return "密碼須介於 8 - 64 個字元。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a208156592 = messageFormatterFn((function(  ) {
  return function(d) { return "密碼不得與電子郵件地址相同。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a710493293 = messageFormatterFn((function(  ) {
  return function(d) { return "密碼不可以包含空格。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1778819685 = messageFormatterFn((function(  ) {
  return function(d) { return "註冊帳戶即表示我同意 " + d["0"] + "<a href=" + d["1"] + " " + d["3"] + ">條款和條件</a>及<a href=" + d["2"] + " " + d["4"] + ">隱私權聲明</a>。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a586807837 = messageFormatterFn((function(  ) {
  return function(d) { return "註冊帳戶即表示我同意 " + d["0"] + "<a href=" + d["1"] + " " + d["5"] + ">條款和條件</a>、<a href=" + d["2"] + " " + d["6"] + ">隱私權聲明</a>及 <a href=" + d["3"] + " " + d["7"] + "> " + d["4"] + "條款和條件</a>。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a666830078 = messageFormatterFn((function(  ) {
  return function(d) { return "我想收到 " + d["0"] + "的旅遊優惠、特價活動和其他資訊的電子報。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a441526833 = messageFormatterFn((function(  ) {
  return function(d) { return "我想收到 " + d["0"] + "的旅遊優惠、特價活動和其他資訊的電子報 ( 您隨時可以取消訂閱)。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b114257471 = messageFormatterFn((function(  ) {
  return function(d) { return "我想收到 " + d["0"] + " 的旅遊推薦、特價活動和其他資訊的電子報。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1051963982 = messageFormatterFn((function(  ) {
  return function(d) { return "我想收到 " + d["0"] + "的旅遊優惠、特價活動和其他資訊的電子報 ( 您隨時可以取消訂閱)。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1013960062 = messageFormatterFn((function(  ) {
  return function(d) { return "繼續"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a27009105 = messageFormatterFn((function(  ) {
  return function(d) { return "已經有帳戶了？<span><a id=\"signinRedirectLink\" href=" + d["0"] + ">登入</a></span>"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1492552500 = messageFormatterFn((function(  ) {
  return function(d) { return "歡迎 " + d["0"] + "！"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1458145286 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " 帳戶到手，世界任您遨遊。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1408184899 = messageFormatterFn((function(  ) {
  return function(d) { return "繼續"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1062614802 = messageFormatterFn((function(  ) {
  return function(d) { return "您需要安全性更高的密碼才能繼續"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1050331443 = messageFormatterFn((function(  ) {
  return function(d) { return "長度必須為至少 8 個字元。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b576156969 = messageFormatterFn((function(  ) {
  return function(d) { return "密碼強度"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a2101118091 = messageFormatterFn((function(  ) {
  return function(d) { return "弱"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1216099862 = messageFormatterFn((function(  ) {
  return function(d) { return "強"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b933643968 = messageFormatterFn((function(  ) {
  return function(d) { return "很強"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1970777125 = messageFormatterFn((function(  ) {
  return function(d) { return "避免使用容易猜到的替換字，例如將「a」換成「@」。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1714931917 = messageFormatterFn((function(  ) {
  return function(d) { return "避免使用倒過來拼的常見字。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a62678667 = messageFormatterFn((function(  ) {
  return function(d) { return "部分字母大寫，而不是全部都大寫。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b108947284 = messageFormatterFn((function(  ) {
  return function(d) { return "挑一些首字外的字母大寫。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b535176272 = messageFormatterFn((function(  ) {
  return function(d) { return "避免與您相關的日期和年份。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b2111138330 = messageFormatterFn((function(  ) {
  return function(d) { return "避免最近的年份。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1019888833 = messageFormatterFn((function(  ) {
  return function(d) { return "避免與您相關的年份。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b2053952500 = messageFormatterFn((function(  ) {
  return function(d) { return "避免常見的字母順序。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1640982682 = messageFormatterFn((function(  ) {
  return function(d) { return "避免重複字或字母。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1159779766 = messageFormatterFn((function(  ) {
  return function(d) { return "避免同樣的文數字組合，並多次變更輸入順序。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1917424751 = messageFormatterFn((function(  ) {
  return function(d) { return "加入更多不常見的字。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b624360805 = messageFormatterFn((function(  ) {
  return function(d) { return "使用多個字詞組合，但避免常見字句。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1012267074 = messageFormatterFn((function(  ) {
  return function(d) { return "即使不使用符號、數字或大寫字母，密碼強度也可以很高。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1090923067 = messageFormatterFn((function(  ) {
  return function(d) { return "此電子郵件地址已註冊 " + d["0"] + "帳戶"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b305845399 = messageFormatterFn((function(  ) {
  return function(d) { return "我們會透過電子郵件寄送連結給您完成帳戶註冊。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1542223768 = messageFormatterFn((function(  ) {
  return function(d) { return "正在建立帳戶..."; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a342941572 = messageFormatterFn((function(  ) {
  return function(d) { return "名字必須至少 2 個英文字母"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1515309802 = messageFormatterFn((function(  ) {
  return function(d) { return "姓氏必須至少 2 個英文字母"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1590991410 = messageFormatterFn((function(  ) {
  return function(d) { return "名字不得超過 100 個英文字母"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1531607656 = messageFormatterFn((function(  ) {
  return function(d) { return "姓氏不得超過 100 個英文字母"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a356097197 = messageFormatterFn((function(  ) {
  return function(d) { return "名字不得包含特殊字元"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1720534675 = messageFormatterFn((function(  ) {
  return function(d) { return "姓氏不得包含特殊字元"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1290094923 = messageFormatterFn((function(  ) {
  return function(d) { return "我同意以下所有敘述"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1261866007 = messageFormatterFn((function(  ) {
  return function(d) { return "我確認我已年滿 18 歲，且已閱讀並同意<a href=" + d["0"] + " " + d["1"] + ">使用條款</a>和<a href=" + d["2"] + " " + d["3"] + ">" + d["4"] + "條款和條件</a> (須同意)。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1841955957 = messageFormatterFn((function(  ) {
  return function(d) { return "我同意依照<a href=" + d["0"] + " " + d["1"] + ">隱私權聲明</a>所述收集和使用我的個資 (須同意)"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1107106718 = messageFormatterFn((function(  ) {
  return function(d) { return "我同意依照<a href=" + d["0"] + " " + d["1"] + ">隱私權聲明</a>所述向韓國和海外的第三方提供我的個資 (須同意)"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b125687969 = messageFormatterFn((function(  ) {
  return function(d) { return "請先同意相關條款再繼續。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a628416283 = messageFormatterFn((function(  ) {
  return function(d) { return "請先接受相關條款再繼續"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b608640809 = messageFormatterFn((function(  ) {
  return function(d) { return "請先勾選此方塊再繼續"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b230779056 = messageFormatterFn((function(  ) {
  return function(d) { return "或註冊 " + d["0"] + " 帳戶"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b980470546 = messageFormatterFn((function(  ) {
  return function(d) { return "請勿使用空格、您的姓名、電子郵件或過去曾使用過的密碼。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b795182034 = messageFormatterFn((function(  ) {
  return function(d) { return "很抱歉，系統發生錯誤。請稍待幾分鐘，然後再試一次。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1737398420 = messageFormatterFn((function(  ) {
  return function(d) { return "驗證您的手機號碼"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1846495867 = messageFormatterFn((function(  ) {
  return function(d) { return "我們會傳送一次性的驗證碼到您的手機，確保您的帳戶安全。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1103912834 = messageFormatterFn((function(  ) {
  return function(d) { return "傳送"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b835070971 = messageFormatterFn((function(  ) {
  return function(d) { return "© " + d["1"] + " " + d["0"] + "。著作權所有，並保留一切權利。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1980514131 = messageFormatterFn((function(  ) {
  return function(d) { return "條款和條件"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1270553812 = messageFormatterFn((function(  ) {
  return function(d) { return "隱私權政策"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1123660427 = messageFormatterFn((function(  ) {
  return function(d) { return "傳簡訊給我"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a118358976 = messageFormatterFn((function(  ) {
  return function(d) { return "輸入驗證碼"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a151676210 = messageFormatterFn((function(  ) {
  return function(d) { return "驗證碼"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1101868187 = messageFormatterFn((function(  ) {
  return function(d) { return "重新傳送驗證碼"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a157755910 = messageFormatterFn((function(  ) {
  return function(d) { return "變更手機號碼"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1945182062 = messageFormatterFn((function(  ) {
  return function(d) { return "已重新傳送驗證碼。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a478838361 = messageFormatterFn((function(  ) {
  return function(d) { return "請輸入我們傳送到 " + d["0"] + " 的 6 位數驗證碼"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1183384212 = messageFormatterFn((function(  ) {
  return function(d) { return "正在確認驗證碼"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1252015885 = messageFormatterFn((function(  ) {
  return function(d) { return "驗證碼錯誤，請按重新傳送驗證碼然後再試一次。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1719415117 = messageFormatterFn((function(  ) {
  return function(d) { return "或透過以下帳戶登入"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1819339971 = messageFormatterFn((function(  ) {
  return function(d) { return "免費註冊會員，立即享有數萬間飯店平均 " + d["0"] + "% 折扣優惠！"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a92836945 = messageFormatterFn((function(  ) {
  return function(d) { return "或"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b346092657 = messageFormatterFn((function(  ) {
  return function(d) { return "其他登入方式"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b345733243 = messageFormatterFn((function(  ) {
  return function(d) { return "其他註冊方式"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b120824923 = messageFormatterFn((function(  ) {
  return function(d) { return "使用 Google 帳號註冊"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b28481276 = messageFormatterFn((function(  ) {
  return function(d) { return "登入失敗，請再試一次或註冊新帳戶以繼續。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1395462654 = messageFormatterFn((function(  ) {
  return function(d) { return "無法使用電話號碼登入，請確認您的社群媒體帳戶設定為可共享電子郵件。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a2053990646 = messageFormatterFn((function(  ) {
  return function(d) { return "免費註冊會員，立即享有數萬間飯店至少 " + d["0"] + "% 折扣優惠！"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1840396251 = messageFormatterFn((function(  ) {
  return function(d) { return "使用 Google 帳戶登入"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a744262480 = messageFormatterFn((function(  ) {
  return function(d) { return "使用 NAVER 帳號登入"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b225614534 = messageFormatterFn((function(  ) {
  return function(d) { return "您嘗試登入的次數超過上限，請稍後再試。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1726631629 = messageFormatterFn((function(  ) {
  return function(d) { return "生物辨識登入"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1958311117 = messageFormatterFn((function(  ) {
  return function(d) { return "啟用生物辨識，免輸入密碼即可登入。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a2145294560 = messageFormatterFn((function(  ) {
  return function(d) { return "開始使用"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1566286000 = messageFormatterFn((function(  ) {
  return function(d) { return "稍後再提醒我"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b796450822 = messageFormatterFn((function(  ) {
  return function(d) { return "成功！"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1175950016 = messageFormatterFn((function(  ) {
  return function(d) { return "生物辨識設定完成。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1561557400 = messageFormatterFn((function(  ) {
  return function(d) { return "使用生物辨識登入"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a128057581 = messageFormatterFn((function(  ) {
  return function(d) { return "使用密碼"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b778507640 = messageFormatterFn((function(  ) {
  return function(d) { return "使用生物辨識"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1894202177 = messageFormatterFn((function(  ) {
  return function(d) { return "如要繼續，請更新密碼"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1215516829 = messageFormatterFn((function(  ) {
  return function(d) { return "您必須重設密碼才能登入帳戶。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b384168883 = messageFormatterFn((function(  ) {
  return function(d) { return "重設密碼"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1408544659 = messageFormatterFn((function(  ) {
  return function(d) { return "新會員禮遇"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1028724601 = messageFormatterFn((function(  ) {
  return function(d) { return "我們要送您 $" + d["0"] + " 的點數當作歡迎禮！"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b2046041897 = messageFormatterFn((function(  ) {
  return function(d) { return "點數已存入您的帳戶，第一次預訂時，只要在付款頁面套用點數就能馬上折抵旅費。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1903895099 = messageFormatterFn((function(  ) {
  return function(d) { return "歡迎成為 Expedia 智遊網會員！"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1532027915 = messageFormatterFn((function(  ) {
  return function(d) { return "馬上享受員價省優惠，預訂還能累積點數。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1024184320 = messageFormatterFn((function(  ) {
  return function(d) { return "登入或註冊帳戶"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1719129382 = messageFormatterFn((function(  ) {
  return function(d) { return "免費註冊會員，立即享有數萬間飯店平均 " + d["0"] + "% 折扣優惠！"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1001687208 = messageFormatterFn((function(  ) {
  return function(d) { return "繼續即表示您已閱讀並同意我們的<a href=" + d["1"] + " " + d["3"] + ">條款和條件</a>和<a href=" + d["2"] + " " + d["4"] + ">隱私權聲明</a>。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1835165510 = messageFormatterFn((function(  ) {
  return function(d) { return "繼續即表示您已閱讀並同意我們的<a href=" + d["1"] + " " + d["5"] + ">條款和條件</a>、<a href=" + d["2"] + " " + d["6"] + ">隱私權聲明</a>和 <a href=" + d["3"] + " " + d["7"] + ">" + d["4"] + " 條款和條件</a>。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1808579029 = messageFormatterFn((function(  ) {
  return function(d) { return "繼續即表示您已閱讀並同意我們的<a href=" + d["1"] + " " + d["4"] + ">條款和條件</a>、<a href=" + d["2"] + " " + d["5"] + ">隱私權聲明</a>和 <a href=" + d["3"] + " " + d["6"] + ">One Key 會員計畫條款和條件</a>。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1904652079 = messageFormatterFn((function(  ) {
  return function(d) { return "電子郵件"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b2144797527 = messageFormatterFn((function(  ) {
  return function(d) { return "請輸入有效的電子郵件地址。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b51840660 = messageFormatterFn((function(  ) {
  return function(d) { return "Google"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b36837191 = messageFormatterFn((function(  ) {
  return function(d) { return "Facebook"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1694770851 = messageFormatterFn((function(  ) {
  return function(d) { return "Apple"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a767010218 = messageFormatterFn((function(  ) {
  return function(d) { return "僅適用於個人裝置。為保護您的帳戶安全，請勿在共用裝置上勾選此選項。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1143105465 = messageFormatterFn((function(  ) {
  return function(d) { return "嘗試登入次數超過上限，請 " + d["0"] + " 分鐘後再試。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1273894923 = messageFormatterFn((function(  ) {
  return function(d) { return "嘗試登入次數超過上限，請 " + d["0"] + " 分鐘後再試。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1278790257 = messageFormatterFn((function(  ) {
  return function(d) { return "嘗試登入次數超過上限，請 " + d["0"] + " 分鐘後再試。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1265332413 = messageFormatterFn((function(  ) {
  return function(d) { return "嘗試登入次數超過上限，請 " + d["0"] + " 分鐘後再試。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a767122864 = messageFormatterFn((function(  ) {
  return function(d) { return "嘗試登入次數超過上限，請 " + d["0"] + " 分鐘後再試。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a323904437 = messageFormatterFn((function(  ) {
  return function(d) { return "嘗試登入次數超過上限，請 " + d["0"] + " 分鐘後再試。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1892682852 = messageFormatterFn((function(  ) {
  return function(d) { return "使用同一個帳戶，在 Expedia 智遊網、Hotels.com 和 Vrbo 上享受數不清的優惠。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1910753196 = messageFormatterFn((function(  ) {
  return function(d) { return "使用同一個帳戶，即可在 Expedia 智遊網、Hotels.com 和 Vrbo 上預訂全球行程。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1542078117 = messageFormatterFn((function(  ) {
  return function(d) { return "瀏覽和儲存住宿、與同行者一起規劃，並輕鬆存取預訂詳情。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a56921818 = messageFormatterFn((function(  ) {
  return function(d) { return "我們進行了例行性的安全檢查，您的帳戶暫時停用。您的資訊都安全無虞，但需要重設一組密碼。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1367276886 = messageFormatterFn((function(  ) {
  return function(d) { return "登入並預訂住宿，就能獲得 OneKeyCash"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b534016194 = messageFormatterFn((function(  ) {
  return function(d) { return "確認您的身分"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b2064106788 = messageFormatterFn((function(  ) {
  return function(d) { return "請輸入我們以電子郵件寄給您的安全驗證碼，如果收件匣中找不到此電子郵件，請檢查垃圾郵件夾。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a634344720 = messageFormatterFn((function(  ) {
  return function(d) { return "讓我們確認您的電子郵件"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1839084598 = messageFormatterFn((function(  ) {
  return function(d) { return "若要繼續，請輸入我們傳送至 " + d["0"] + " 的安全驗證碼。如果收件匣中找不到此電子郵件，請檢查垃圾郵件夾。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b415505028 = messageFormatterFn((function(  ) {
  return function(d) { return "6 位數驗證碼"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b233776900 = messageFormatterFn((function(  ) {
  return function(d) { return "重新傳送驗證碼"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b750055853 = messageFormatterFn((function(  ) {
  return function(d) { return "(0:" + d["0"] + ")"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b343075483 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " 秒後重新傳送驗證碼"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a213736565 = messageFormatterFn((function(  ) {
  return function(d) { return "還沒收到電子郵件嗎？"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1796296365 = messageFormatterFn((function(  ) {
  return function(d) { return "您可在 " + d["0"] + " 秒後要求重新寄送驗證碼"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1442862922 = messageFormatterFn((function(  ) {
  return function(d) { return "要求另一組安全驗證碼"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1758330304 = messageFormatterFn((function(  ) {
  return function(d) { return "已傳送新的 6 位數驗證碼到電子信箱。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1340375285 = messageFormatterFn((function(  ) {
  return function(d) { return "改為輸入密碼"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b2060510314 = messageFormatterFn((function(  ) {
  return function(d) { return "驗證碼無效，請再試一次。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1125958340 = messageFormatterFn((function(  ) {
  return function(d) { return "驗證碼失效，請重寄然後再試一次。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1411958969 = messageFormatterFn((function(  ) {
  return function(d) { return "如果收件匣中找不到此電子郵件，請檢查垃圾郵件夾。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a668584800 = messageFormatterFn((function(  ) {
  return function(d) { return "我們更新了服務體驗，需要請您確認電子郵件。請輸入我們寄到收件匣的安全驗證碼。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a607848351 = messageFormatterFn((function(  ) {
  return function(d) { return "系統發生錯誤，請再試一次。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1683198616 = messageFormatterFn((function(  ) {
  return function(d) { return "請輸入我們以電子郵件寄給您的安全驗證碼，以更新登入方式。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b22698210 = messageFormatterFn((function(  ) {
  return function(d) { return "請輸入您的密碼"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a677777239 = messageFormatterFn((function(  ) {
  return function(d) { return "透過電子郵件傳送安全碼"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1325960663 = messageFormatterFn((function(  ) {
  return function(d) { return "電子郵件或密碼有誤"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1361956338 = messageFormatterFn((function(  ) {
  return function(d) { return "設定密碼"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1338689137 = messageFormatterFn((function(  ) {
  return function(d) { return "建立密碼 | " + d["0"]; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a802560860 = messageFormatterFn((function(  ) {
  return function(d) { return "設定密碼"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1556075006 = messageFormatterFn((function(  ) {
  return function(d) { return "您可以使用同一組電子郵件和密碼登入 Expedia 智遊網、Hotels.com 和 Vrbo。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1631896162 = messageFormatterFn((function(  ) {
  return function(d) { return "設定密碼"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b703485317 = messageFormatterFn((function(  ) {
  return function(d) { return "除了其它安全登入的方式以外，請設定一組密碼。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1697048496 = messageFormatterFn((function(  ) {
  return function(d) { return "設定新密碼"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1160825331 = messageFormatterFn((function(  ) {
  return function(d) { return "設定新密碼 | " + d["0"]; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a703577498 = messageFormatterFn((function(  ) {
  return function(d) { return "設定新密碼"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b909697280 = messageFormatterFn((function(  ) {
  return function(d) { return "您可以使用一組帳號和密碼登入 Expedia 智遊網、Hotels.com 和 Vrbo。為您的合併帳戶設定安全密碼。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a635387424 = messageFormatterFn((function(  ) {
  return function(d) { return "設定密碼"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a552281160 = messageFormatterFn((function(  ) {
  return function(d) { return "變更密碼"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a2066300507 = messageFormatterFn((function(  ) {
  return function(d) { return "變更密碼 | " + d["0"]; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a782827880 = messageFormatterFn((function(  ) {
  return function(d) { return "請設定特別且強度高的密碼。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b263626056 = messageFormatterFn((function(  ) {
  return function(d) { return "更新密碼"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1032760283 = messageFormatterFn((function(  ) {
  return function(d) { return "無法變更密碼，請再試一次。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b33154941 = messageFormatterFn((function(  ) {
  return function(d) { return "忘記密碼"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1622904969 = messageFormatterFn((function(  ) {
  return function(d) { return "請輸入您的電子郵件，我們會將登入用的安全驗證碼寄送給您。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a668337737 = messageFormatterFn((function(  ) {
  return function(d) { return "傳送電子郵件"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1855961365 = messageFormatterFn((function(  ) {
  return function(d) { return "聯絡我們"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b2016737158 = messageFormatterFn((function(  ) {
  return function(d) { return "刪除帳戶"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1568907055 = messageFormatterFn((function(  ) {
  return function(d) { return "關閉"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a748980691 = messageFormatterFn((function(  ) {
  return function(d) { return "正在檢查您的帳戶，請稍候。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b712694004 = messageFormatterFn((function(  ) {
  return function(d) { return "刪除帳戶"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1136909936 = messageFormatterFn((function(  ) {
  return function(d) { return "我知道了"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a193455828 = messageFormatterFn((function(  ) {
  return function(d) { return "行程完成前無法刪除帳戶"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1337362315 = messageFormatterFn((function(  ) {
  return function(d) { return "很抱歉，為確保您的行程一切順暢，或臨時需要聯絡客服變更預訂，我們會暫時保留帳戶。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1182797634 = messageFormatterFn((function(  ) {
  return function(d) { return "很抱歉，請先刪除您的 Vrbo 屋主帳戶"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a360861305 = messageFormatterFn((function(  ) {
  return function(d) { return "請前往我們網站或 App 的說明中心，直接聯絡客服進行處理。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1698573271 = messageFormatterFn((function(  ) {
  return function(d) { return "請於行程結束後再刪除帳戶。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1526361274 = messageFormatterFn((function(  ) {
  return function(d) { return "刪除帳戶的原因"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1198933239 = messageFormatterFn((function(  ) {
  return function(d) { return "收到太多電子郵件或通知"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1766395233 = messageFormatterFn((function(  ) {
  return function(d) { return "有另一個 " + d["0"] + " 帳戶"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1101691878 = messageFormatterFn((function(  ) {
  return function(d) { return "行程已結束，不需要帳戶了"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1659990048 = messageFormatterFn((function(  ) {
  return function(d) { return "使用 " + d["0"] + " 預訂的體驗不佳"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1437221055 = messageFormatterFn((function(  ) {
  return function(d) { return "其他"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b114754530 = messageFormatterFn((function(  ) {
  return function(d) { return "略過"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b674255579 = messageFormatterFn((function(  ) {
  return function(d) { return "送出"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1554123189 = messageFormatterFn((function(  ) {
  return function(d) { return "確定要刪除嗎？提醒您："; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a719167224 = messageFormatterFn((function(  ) {
  return function(d) { return "您現有的 " + d["0"] + " 點 Expedia Rewards (價值 " + d["1"] + ")、" + d["2"] + " 的抵用金、優惠券、儲存的行程和偏好設定都會永久移除。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1095962823 = messageFormatterFn((function(  ) {
  return function(d) { return "您現有的 " + d["0"] + " 點 Expedia Rewards (價值 " + d["1"] + ")、優惠券、儲存的行程和偏好設定都會永久移除。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b992647941 = messageFormatterFn((function(  ) {
  return function(d) { return "您的行程板、抵用金和偏好設定都會永久移除。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1235667215 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotels.com Rewards：您將會損失 " + d["0"] + " 晚獎勵住宿 (價值 " + d["1"] + ")，以及 " + d["2"] + " 個印花 (價值 " + d["3"] + ")。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a87229890 = messageFormatterFn((function(  ) {
  return function(d) { return "您現有的抵用金、優惠券、儲存的行程和偏好設定都會永久移除。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1517277846 = messageFormatterFn((function(  ) {
  return function(d) { return "您現有的 " + d["0"] + " CheapCash (價值 " + d["1"] + ")、" + d["2"] + " 的抵用金、優惠券、儲存的行程和偏好設定都會永久移除。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b141474425 = messageFormatterFn((function(  ) {
  return function(d) { return "您現有的 " + d["0"] + " CheapCash (價值 " + d["1"] + ")、優惠券、儲存的行程和偏好設定都會永久移除。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a230228706 = messageFormatterFn((function(  ) {
  return function(d) { return "您現有的 " + d["0"] + " Orbucks (價值 " + d["1"] + ")、" + d["2"] + " 的抵用金、優惠券、儲存的行程和偏好設定都會永久移除。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b800664305 = messageFormatterFn((function(  ) {
  return function(d) { return "您現有的 " + d["0"] + " Orbucks (價值 " + d["1"] + ")、優惠券、儲存的行程和偏好設定都會永久移除。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b97746312 = messageFormatterFn((function(  ) {
  return function(d) { return "您現有的 " + d["0"] + " MrJet Rewards (價值 " + d["1"] + ")、" + d["2"] + " 的抵用金、優惠券、儲存的行程和偏好設定都會永久移除。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1360321465 = messageFormatterFn((function(  ) {
  return function(d) { return "您現有的 " + d["0"] + " MrJet Rewards (價值 " + d["1"] + ")、優惠券、儲存的行程和偏好設定都會永久移除。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a668224394 = messageFormatterFn((function(  ) {
  return function(d) { return "您現有的 " + d["0"] + " BONUS+ (價值 " + d["1"] + ")、" + d["2"] + " 的抵用金、優惠券、儲存的行程和偏好設定都會永久移除。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b362605721 = messageFormatterFn((function(  ) {
  return function(d) { return "您現有的 " + d["0"] + " BONUS+ (價值 " + d["1"] + ")、優惠券、儲存的行程和偏好設定都會永久移除。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1578620396 = messageFormatterFn((function(  ) {
  return function(d) { return "您現有的優惠券、儲存的行程和偏好設定都會永久移除。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a988415017 = messageFormatterFn((function(  ) {
  return function(d) { return "您現有的 " + d["0"] + " 的抵用金、優惠券、儲存的行程和偏好設定都會永久移除。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a968933741 = messageFormatterFn((function(  ) {
  return function(d) { return "我們可能會保留您的交易記錄等部分資訊，以履行法律義務或建立、行使或捍衛法律主張。我們會安全保留這些資訊，不再需要後將會刪除、匿名或永久模糊處理。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b394083297 = messageFormatterFn((function(  ) {
  return function(d) { return "永久刪除帳戶"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1008381391 = messageFormatterFn((function(  ) {
  return function(d) { return "不刪除帳戶"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1508851495 = messageFormatterFn((function(  ) {
  return function(d) { return "期待有緣再相見～"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a37488648 = messageFormatterFn((function(  ) {
  return function(d) { return "刪除帳戶可能需要幾週的處理時間，更新完成前，您可能暫時還是會收到我們的電子通訊。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1850333406 = messageFormatterFn((function(  ) {
  return function(d) { return "請再試一次"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a414548415 = messageFormatterFn((function(  ) {
  return function(d) { return "系統發生錯誤，請重新刪除帳戶，或稍後再試。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1651864135 = messageFormatterFn((function(  ) {
  return function(d) { return "關閉"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b324496032 = messageFormatterFn((function(  ) {
  return function(d) { return "請輸入旅行證件上的姓名"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b82325136 = messageFormatterFn((function(  ) {
  return function(d) { return "請將帳戶姓名設定為護照或駕照等旅行證件上的英文姓名，下次預訂時，系統會自動帶入資料。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b876450594 = messageFormatterFn((function(  ) {
  return function(d) { return "以電子郵件寄給我 " + d["0"] + " 的優惠、折扣和其他好康資訊。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a828214865 = messageFormatterFn((function(  ) {
  return function(d) { return "以電子郵件寄給我 " + d["0"] + " 的優惠、折扣和其他好康資訊。您可以隨時取消訂閱。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1554052620 = messageFormatterFn((function(  ) {
  return function(d) { return "帳戶資訊"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a945383959 = messageFormatterFn((function(  ) {
  return function(d) { return "帳戶資訊 | " + d["0"]; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a923867746 = messageFormatterFn((function(  ) {
  return function(d) { return "接收 " + d["0"] + " 優惠、折扣和其他資訊的電子郵件。您可以隨時取消訂閱。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1204227178 = messageFormatterFn((function(  ) {
  return function(d) { return "帳戶 | " + d["0"]; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b964315714 = messageFormatterFn((function(  ) {
  return function(d) { return "資訊不漏接"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1459718424 = messageFormatterFn((function(  ) {
  return function(d) { return "同意接收行銷資訊"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1574292855 = messageFormatterFn((function(  ) {
  return function(d) { return "Expedia Rewards"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b449038773 = messageFormatterFn((function(  ) {
  return function(d) { return "CheapCash"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b573470589 = messageFormatterFn((function(  ) {
  return function(d) { return "Orbitz Rewards"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1407315179 = messageFormatterFn((function(  ) {
  return function(d) { return "BONUS+"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1509145417 = messageFormatterFn((function(  ) {
  return function(d) { return "MrJet"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b2039366510 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotels.com Rewards"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1985509882 = messageFormatterFn((function(  ) {
  return function(d) { return "One Key"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a174083559 = messageFormatterFn((function(  ) {
  return function(d) { return "很抱歉，請等行程結束後再刪除"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1276309705 = messageFormatterFn((function(  ) {
  return function(d) { return "很抱歉，請等行程結束後再刪除"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1770801041 = messageFormatterFn((function(  ) {
  return function(d) { return "您可以利用帳戶查看預訂詳情和取得必要協助，請在行程結束後再刪除。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a153205235 = messageFormatterFn((function(  ) {
  return function(d) { return "您可以利用帳戶查看預訂詳情和取得必要協助，請在行程結束後再刪除。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a5799404 = messageFormatterFn((function(  ) {
  return function(d) { return "很抱歉，目前無法刪除帳戶"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1442453782 = messageFormatterFn((function(  ) {
  return function(d) { return "此帳戶目前也有在 Vrbo 上刊登房屋，請先登入 Vrbo 屋主 App 或網站移除刊登的房屋。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a275995865 = messageFormatterFn((function(  ) {
  return function(d) { return "請選擇您刪除帳戶的原因。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a225187186 = messageFormatterFn((function(  ) {
  return function(d) { return "我有使用另一組電子郵件註冊帳戶"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1464794611 = messageFormatterFn((function(  ) {
  return function(d) { return "預訂體驗不佳"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1305279480 = messageFormatterFn((function(  ) {
  return function(d) { return "很遺憾您決定不再使用我們的帳戶，刪除帳戶不可逆，且會影響到您在 Expedia 智遊網、Hotels.com 和 Vrbo 上的資料。提醒您："; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1107283667 = messageFormatterFn((function(  ) {
  return function(d) { return "很遺憾您決定不再使用我們的帳戶，刪除帳戶不可逆，且會影響到您在 Expedia 智遊網、Wotif、Hotels.com 和 Vrbo 上的資料。提醒您："; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b211675212 = messageFormatterFn((function(  ) {
  return function(d) { return "您在 Expedia 智遊網、Hotels.com 和 Vrbo 上的帳戶紀錄、偏好設定和儲存項目將永久移除。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1157919103 = messageFormatterFn((function(  ) {
  return function(d) { return "您在 Expedia 智遊網、Wotif、Hotels.com 和 Vrbo 上的帳戶紀錄、偏好設定和儲存項目將永久移除。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1093772952 = messageFormatterFn((function(  ) {
  return function(d) { return "您將喪失所有累積的 OneKeyCash (包含待入帳的金額)，以及 One Key 等級和所有相對應的禮遇。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b746660258 = messageFormatterFn((function(  ) {
  return function(d) { return "您將喪失所有待入帳的 OneKeyCash，以及 One Key 等級和所有相對應的禮遇。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1075589581 = messageFormatterFn((function(  ) {
  return function(d) { return "您將喪失 " + d["0"] + " OneKeyCash (包含待入帳的金額)，以及 One Key 等級和所有相對應的禮遇。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1270975191 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotels.com Rewards 信用卡持卡人將無法再透過信用卡消費賺取獎勵。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1515225670 = messageFormatterFn((function(  ) {
  return function(d) { return "您的 Expedia Rewards 點數 (包含帳戶內和待入帳的點數)、Hotels.com Rewards 印花和獎勵住宿，以及獎勵等級將永久失效。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b391537604 = messageFormatterFn((function(  ) {
  return function(d) { return "您待入帳的 Expedia Rewards 點數、Hotels.com Rewards 印花和獎勵住宿，以及獎勵等級將永久失效。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b108515198 = messageFormatterFn((function(  ) {
  return function(d) { return "您現有的 Expedia 智遊網、Hotels.com 和 Vrbo 抵用金將全數作廢。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1115932723 = messageFormatterFn((function(  ) {
  return function(d) { return "您現有的 Expedia 智遊網、Wotif、Hotels.com 和 Vrbo 抵用金將全數作廢。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1770276837 = messageFormatterFn((function(  ) {
  return function(d) { return "刪除 Expedia 智遊網、Hotels.com 和 Vrbo 帳戶可能需要幾週的處理時間，更新完成前，您可能暫時還是會收到我們的電子通訊。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1626871642 = messageFormatterFn((function(  ) {
  return function(d) { return "刪除 Expedia 智遊網、Wotif、Hotels.com 和 Vrbo 帳戶可能需要幾週的處理時間，更新完成前，您可能暫時還是會收到我們的電子通訊。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1808716976 = messageFormatterFn((function(  ) {
  return function(d) { return "刪除帳戶後，我們將會關閉您的 One Key Card，您的消費將不會再獲得 OneKeyCash。Wells Fargo 將與您聯絡，以確認您的卡片已關閉。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a504820442 = messageFormatterFn((function(  ) {
  return function(d) { return "刪除帳戶後，我們將會關閉您的 One Key+ Card，您的消費將不會再獲得 OneKeyCash。Wells Fargo 將與您聯絡，以確認您的卡片已關閉。"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1861308783 = messageFormatterFn((function(  ) {
  return function(d) { return "登入或註冊帳戶即可在這次行程賺取 OneKeyCash"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a268389481 = messageFormatterFn((function(  ) {
  return function(d) { return "登入或註冊帳戶即可在這次住宿賺取獎勵"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a851503696 = messageFormatterFn((function(  ) {
  return function(d) { return "以訪客身分結帳"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b1698406850 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " 帳戶登入：新增手機號碼"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1671203122 = messageFormatterFn((function(  ) {
  return function(d) { return "發生錯誤"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1223246292 = messageFormatterFn((function(  ) {
  return function(d) { return "請嘗試重新登入"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a588005963 = messageFormatterFn((function(  ) {
  return function(d) { return "好"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b289978418 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " 標誌"; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.a1813041889 = messageFormatterFn((function(  ) {
  return function(d) { return "帳戶 "; }
})(), Globalize("zh-TW").pluralGenerator({}));
Globalize.b2027578867 = dateToPartsFormatterFn({"2":Globalize("zh-TW").numberFormatter({"raw":"00"}),"4":Globalize("zh-TW").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy-MM-dd","timeSeparator":":"});
Globalize.a1152842061 = dateToPartsFormatterFn({"2":Globalize("zh-TW").numberFormatter({"raw":"00"}),"4":Globalize("zh-TW").numberFormatter({"raw":"0000"})}, {"pattern":"dd/MM/yyyy","timeSeparator":":"});
Globalize.a2069222624 = dateToPartsFormatterFn({"1":Globalize("zh-TW").numberFormatter({"raw":"0"}),"4":Globalize("zh-TW").numberFormatter({"raw":"0000"})}, {"pattern":"d/M/yyyy","timeSeparator":":"});
Globalize.a946768666 = dateToPartsFormatterFn({"1":Globalize("zh-TW").numberFormatter({"raw":"0"}),"4":Globalize("zh-TW").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/M/d","timeSeparator":":"});
Globalize.a1206983085 = dateToPartsFormatterFn({"2":Globalize("zh-TW").numberFormatter({"raw":"00"}),"4":Globalize("zh-TW").numberFormatter({"raw":"0000"})}, {"pattern":"dd.MM.yyyy","timeSeparator":":"});
Globalize.a522925794 = dateToPartsFormatterFn({"1":Globalize("zh-TW").numberFormatter({"raw":"0"}),"4":Globalize("zh-TW").numberFormatter({"raw":"0000"})}, {"pattern":"d.M.yyyy","timeSeparator":":"});
Globalize.b1290262195 = dateToPartsFormatterFn({"2":Globalize("zh-TW").numberFormatter({"raw":"00"}),"4":Globalize("zh-TW").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/MM/dd","timeSeparator":":"});
Globalize.a1261124109 = dateToPartsFormatterFn({"2":Globalize("zh-TW").numberFormatter({"raw":"00"}),"4":Globalize("zh-TW").numberFormatter({"raw":"0000"})}, {"pattern":"dd-MM-yyyy","timeSeparator":":"});
Globalize.a1790618381 = dateToPartsFormatterFn({"2":Globalize("zh-TW").numberFormatter({"raw":"00"}),"4":Globalize("zh-TW").numberFormatter({"raw":"0000"})}, {"pattern":"MM/dd/yyyy","timeSeparator":":"});
Globalize.a1827651232 = dateToPartsFormatterFn({"1":Globalize("zh-TW").numberFormatter({"raw":"0"}),"4":Globalize("zh-TW").numberFormatter({"raw":"0000"})}, {"pattern":"M/d/yyyy","timeSeparator":":"});
Globalize.a488563117 = dateToPartsFormatterFn({"2":Globalize("zh-TW").numberFormatter({"raw":"00"}),"4":Globalize("zh-TW").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy.MM.dd","timeSeparator":":"});
Globalize.a1179370034 = dateToPartsFormatterFn({}, {"pattern":"EEEEE","timeSeparator":":","days":{"E":{"5":{"sun":"日","mon":"一","tue":"二","wed":"三","thu":"四","fri":"五","sat":"六"}}}});
Globalize.b654723315 = dateToPartsFormatterFn({}, {"pattern":"EEEE","timeSeparator":":","days":{"E":{"4":{"sun":"星期日","mon":"星期一","tue":"星期二","wed":"星期三","thu":"星期四","fri":"星期五","sat":"星期六"}}}});
Globalize.b1907968755 = dateToPartsFormatterFn({}, {"pattern":"MMMM","timeSeparator":":","months":{"M":{"4":{"1":"1月","2":"2月","3":"3月","4":"4月","5":"5月","6":"6月","7":"7月","8":"8月","9":"9月","10":"10月","11":"11月","12":"12月"}}}});
Globalize.b1409256717 = dateToPartsFormatterFn({"1":Globalize("zh-TW").numberFormatter({"raw":"0"})}, {"pattern":"d","timeSeparator":":"});
Globalize.a2102374720 = dateToPartsFormatterFn({"1":Globalize("zh-TW").numberFormatter({"raw":"0"}),"2":Globalize("zh-TW").numberFormatter({"raw":"00"})}, {"pattern":"M/d/yy","timeSeparator":":"});
Globalize.b351978111 = dateToPartsFormatterFn({"1":Globalize("zh-TW").numberFormatter({"raw":"0"})}, {"pattern":"M月d日","timeSeparator":":"});
Globalize.a1954219304 = dateToPartsFormatterFn({"1":Globalize("zh-TW").numberFormatter({"raw":"0"})}, {"pattern":"M月d日","timeSeparator":":"});
Globalize.b1786689907 = dateToPartsFormatterFn({"1":Globalize("zh-TW").numberFormatter({"raw":"0"})}, {"pattern":"y年MMMM月d日","timeSeparator":":","months":{"M":{"4":{"1":"1月","2":"2月","3":"3月","4":"4月","5":"5月","6":"6月","7":"7月","8":"8月","9":"9月","10":"10月","11":"11月","12":"12月"}}}});
Globalize.a1327777523 = dateToPartsFormatterFn({"1":Globalize("zh-TW").numberFormatter({"raw":"0"})}, {"pattern":"y年M月","timeSeparator":":"});
Globalize.a1328462716 = dateToPartsFormatterFn({"1":Globalize("zh-TW").numberFormatter({"raw":"0"})}, {"pattern":"y年M月d日","timeSeparator":":"});
Globalize.b1984254655 = dateToPartsFormatterFn({"1":Globalize("zh-TW").numberFormatter({"raw":"0"})}, {"pattern":"MMM月d日 EEEE","timeSeparator":":","months":{"M":{"3":{"1":"1月","2":"2月","3":"3月","4":"4月","5":"5月","6":"6月","7":"7月","8":"8月","9":"9月","10":"10月","11":"11月","12":"12月"}}},"days":{"E":{"4":{"sun":"星期日","mon":"星期一","tue":"星期二","wed":"星期三","thu":"星期四","fri":"星期五","sat":"星期六"}}}});
Globalize.a1946831136 = dateToPartsFormatterFn({"1":Globalize("zh-TW").numberFormatter({"raw":"0"})}, {"pattern":"M月d日 E","timeSeparator":":","days":{"E":{"1":{"sun":"週日","mon":"週一","tue":"週二","wed":"週三","thu":"週四","fri":"週五","sat":"週六"}}}});
Globalize.b1648865116 = dateFormatterFn(Globalize("zh-TW").dateToPartsFormatter({"raw":"yyyy-MM-dd"}));
Globalize.a1531555812 = dateFormatterFn(Globalize("zh-TW").dateToPartsFormatter({"raw":"dd/MM/yyyy"}));
Globalize.b410827465 = dateFormatterFn(Globalize("zh-TW").dateToPartsFormatter({"raw":"d/M/yyyy"}));
Globalize.b1533281423 = dateFormatterFn(Globalize("zh-TW").dateToPartsFormatter({"raw":"yyyy/M/d"}));
Globalize.a1585696836 = dateFormatterFn(Globalize("zh-TW").dateToPartsFormatter({"raw":"dd.MM.yyyy"}));
Globalize.b1957124295 = dateFormatterFn(Globalize("zh-TW").dateToPartsFormatter({"raw":"d.M.yyyy"}));
Globalize.b911548444 = dateFormatterFn(Globalize("zh-TW").dateToPartsFormatter({"raw":"yyyy/MM/dd"}));
Globalize.a1639837860 = dateFormatterFn(Globalize("zh-TW").dateToPartsFormatter({"raw":"dd-MM-yyyy"}));
Globalize.b2125635164 = dateFormatterFn(Globalize("zh-TW").dateToPartsFormatter({"raw":"MM/dd/yyyy"}));
Globalize.b652398857 = dateFormatterFn(Globalize("zh-TW").dateToPartsFormatter({"raw":"M/d/yyyy"}));
Globalize.a867276868 = dateFormatterFn(Globalize("zh-TW").dateToPartsFormatter({"raw":"yyyy.MM.dd"}));
Globalize.a1028196667 = dateFormatterFn(Globalize("zh-TW").dateToPartsFormatter({"raw":"EEEEE"}));
Globalize.b1490883868 = dateFormatterFn(Globalize("zh-TW").dateToPartsFormatter({"raw":"EEEE"}));
Globalize.a1550837988 = dateFormatterFn(Globalize("zh-TW").dateToPartsFormatter({"raw":"MMMM"}));
Globalize.b825973124 = dateFormatterFn(Globalize("zh-TW").dateToPartsFormatter({"raw":"d"}));
Globalize.a1710967639 = dateFormatterFn(Globalize("zh-TW").dateToPartsFormatter({"raw":"M/d/yy"}));
Globalize.a75880458 = dateFormatterFn(Globalize("zh-TW").dateToPartsFormatter({"skeleton":"MMMd"}));
Globalize.b1962034241 = dateFormatterFn(Globalize("zh-TW").dateToPartsFormatter({"skeleton":"MMMMd"}));
Globalize.a1363501782 = dateFormatterFn(Globalize("zh-TW").dateToPartsFormatter({"skeleton":"yMMMMd"}));
Globalize.a1706491274 = dateFormatterFn(Globalize("zh-TW").dateToPartsFormatter({"skeleton":"yMMMM"}));
Globalize.a1707176467 = dateFormatterFn(Globalize("zh-TW").dateToPartsFormatter({"skeleton":"yMMMd"}));
Globalize.a1692982090 = dateFormatterFn(Globalize("zh-TW").dateToPartsFormatter({"skeleton":"MMMEEEEd"}));
Globalize.b1969422409 = dateFormatterFn(Globalize("zh-TW").dateToPartsFormatter({"skeleton":"MMMEd"}));
Globalize.b34803373 = dateParserFn(Globalize("zh-TW").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"yyyy-MM-dd","digitsRe":/\d/});
Globalize.b1149349741 = dateParserFn(Globalize("zh-TW").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"dd/MM/yyyy","digitsRe":/\d/});
Globalize.b1200208474 = dateParserFn(Globalize("zh-TW").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"d/M/yyyy","digitsRe":/\d/});
Globalize.a1972304864 = dateParserFn(Globalize("zh-TW").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"yyyy/M/d","digitsRe":/\d/});
Globalize.b1095208717 = dateParserFn(Globalize("zh-TW").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"dd.MM.yyyy","digitsRe":/\d/});
Globalize.a1548461992 = dateParserFn(Globalize("zh-TW").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"d.M.yyyy","digitsRe":/\d/});
Globalize.a702513299 = dateParserFn(Globalize("zh-TW").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"yyyy/MM/dd","digitsRe":/\d/});
Globalize.b1041067693 = dateParserFn(Globalize("zh-TW").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"dd-MM-yyyy","digitsRe":/\d/});
Globalize.b511573421 = dateParserFn(Globalize("zh-TW").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"MM/dd/yyyy","digitsRe":/\d/});
Globalize.b1441779866 = dateParserFn(Globalize("zh-TW").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"M/d/yyyy","digitsRe":/\d/});
Globalize.b1813628685 = dateParserFn(Globalize("zh-TW").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"yyyy.MM.dd","digitsRe":/\d/});
Globalize.b1460635860 = dateParserFn(Globalize("zh-TW").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"EEEEE","digitsRe":/\d/,"gregorian/days/format/narrow":[["sun",/^日/],["mon",/^一/],["tue",/^二/],["wed",/^三/],["thu",/^四/],["fri",/^五/],["sat",/^六/]]});
Globalize.a1892514515 = dateParserFn(Globalize("zh-TW").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"EEEE","digitsRe":/\d/,"gregorian/days/format/wide":[["sun",/^星期日/],["mon",/^星期一/],["tue",/^星期二/],["wed",/^星期三/],["thu",/^星期四/],["fri",/^星期五/],["sat",/^星期六/]]});
Globalize.a639269075 = dateParserFn(Globalize("zh-TW").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"MMMM","digitsRe":/\d/,"gregorian/months/format/wide":[["10",/^10月/],["11",/^11月/],["12",/^12月/],["1",/^1月/],["2",/^2月/],["3",/^3月/],["4",/^4月/],["5",/^5月/],["6",/^6月/],["7",/^7月/],["8",/^8月/],["9",/^9月/]]});
Globalize.a1911207149 = dateParserFn(Globalize("zh-TW").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"d","digitsRe":/\d/});
Globalize.a1866570630 = dateParserFn(Globalize("zh-TW").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"M/d/yy","digitsRe":/\d/});
Globalize.a1374872955 = dateParserFn(Globalize("zh-TW").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"M月d日","digitsRe":/\d/});
Globalize.b347972498 = dateParserFn(Globalize("zh-TW").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"M月d日","digitsRe":/\d/});
Globalize.b140191737 = dateParserFn(Globalize("zh-TW").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"y年MMMM月d日","digitsRe":/\d/,"gregorian/months/format/wide":[["10",/^10月/],["11",/^11月/],["12",/^12月/],["1",/^1月/],["2",/^2月/],["3",/^3月/],["4",/^4月/],["5",/^5月/],["6",/^6月/],["7",/^7月/],["8",/^8月/],["9",/^9月/]]});
Globalize.b974414279 = dateParserFn(Globalize("zh-TW").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"y年M月","digitsRe":/\d/});
Globalize.b973729086 = dateParserFn(Globalize("zh-TW").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"y年M月d日","digitsRe":/\d/});
Globalize.b247478213 = dateParserFn(Globalize("zh-TW").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"MMM月d日 EEEE","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["10",/^10月/],["11",/^11月/],["12",/^12月/],["1",/^1月/],["2",/^2月/],["3",/^3月/],["4",/^4月/],["5",/^5月/],["6",/^6月/],["7",/^7月/],["8",/^8月/],["9",/^9月/]],"gregorian/days/format/wide":[["sun",/^星期日/],["mon",/^星期一/],["tue",/^星期二/],["wed",/^星期三/],["thu",/^星期四/],["fri",/^星期五/],["sat",/^星期六/]]});
Globalize.b355360666 = dateParserFn(Globalize("zh-TW").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"M月d日 E","digitsRe":/\d/,"gregorian/days/format/abbreviated":[["sun",/^週日/],["mon",/^週一/],["tue",/^週二/],["wed",/^週三/],["thu",/^週四/],["fri",/^週五/],["sat",/^週六/]]});
module.exports = Globalize;
